import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApplicationInsightsService } from '../../../services/application-insights.service';
import { IEvaluationData } from '../../../interfaces/evaluation-data';
import { EvaluationDataService } from '../../../services/evaluation-data.service';

@Component({
  selector: 'expired',
  templateUrl: './expired.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ExpiredComponent implements OnInit {
  get evaluationData(): IEvaluationData {
    return this.evaluationDataService.evaluationData.value;
  }

  constructor(
    private evaluationDataService: EvaluationDataService,
    private applicationInsights: ApplicationInsightsService
  ) {}

  ngOnInit() {
    if (this.evaluationData && this.evaluationData.EvaluationId) {
      this.applicationInsights.trackEvent('EvaluationExpired', {
        evaluationId: this.evaluationData.EvaluationId
      });
    }
  }
}
